var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8179 0.744793C19.5189 0.655033 15.0828 3.12108 13.8687 8.67204C8.91772 6.98549 4.44861 10.3161 4.91158 15.6403C3.60615 16.1674 2.48833 17.0731 1.70197 18.2408C0.915616 19.4086 0.496707 20.7849 0.499156 22.1928C0.499156 26.1091 3.65494 29.2602 7.57132 29.2602H16.16L16.1505 21.2007L14.138 21.9329C12.6735 22.5613 11.5964 20.7188 12.8483 19.5708L16.6607 15.8718C17.53 15.0025 18.5693 15.1017 19.3394 15.8718L23.1518 19.5755C24.4037 20.7188 23.3219 22.5613 21.8621 21.9329L19.8496 21.2007V29.2602H28.424C32.3404 29.2602 35.4915 26.1091 35.4915 22.1928C35.4915 19.311 33.7813 16.8449 31.32 15.7442C36.0915 6.43748 30.1011 0.867623 23.8179 0.744793Z",
    fill: "#C0CEF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8181 0.73999C23.5818 0.73999 23.3173 0.744715 23.0763 0.754163C17.5868 9.40894 26.0715 15.7394 31.3248 15.7394C36.0963 6.43268 30.1013 0.867544 23.8181 0.73999Z",
    fill: "url(#paint0_linear_5984_6266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5984_6266",
    x1: 27.1727,
    y1: 0.73999,
    x2: 27.1727,
    y2: 15.7394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/uploadCloud.67566e527005702890dffcd7ec1d5387.svg";
export { ForwardRef as ReactComponent };